import { ExtendableError } from 'ts-error';

export class UnauthorizedException extends ExtendableError { }
